export default "__VITE_ASSET__BeQuEyzc__"